module.exports = __webpack_public_path__ + "img/rodriguez.e6bcdb41.jpg";